/**
 * @Description: claimOrderList 认领列表
 */

/** 列表 */
export const API_SETTLE_STATEMENTSOURCEBILL_CLAIMORDERLIST = {
    url: 'statementSourceBill/claimOrderList',
    config: {
      method: 'post',
      host: 'CAISX_SETTLE',
    },
  };
  
 